import Model  from '@/util/models';

export default class Voucher extends Model { 
    backend = '/master/voucher/'; 
    
    index(params = {}){
        return this.api.get(this.backend + 'index', params).then(res => {          
          return res.status == 200 ? res.data : {};
        });
    }
}

